module.exports = {
  env: 'production',
  apiUrl: '',
  webSocketConnectedMediumsEndpoint: process.env.VUE_APP_SELF_WEBSOCKET_BASE_URL + "/ws/v1/mediums/connected",
  authConfig: {}
}
